var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSvgNopadding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 788 634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        isolation: isolate;\n      }\n\n      .st1 {\n        fill: #19a7ce;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.13,294.29h161.64v-161.64h54.11v161.64h161.64v54.11h-161.64v161.64h-54.11v-161.64h-161.64v-54.11Z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.63,290.36c16.54-.46,30.33-4.59,41.36-12.41,11.03-7.81,18.78-19.18,23.26-34.12,4.48-14.93,6.72-41.7,6.72-80.3,0-49.4,2.76-83.75,8.27-103.05,5.51-19.3,16.08-33.78,31.71-43.43,15.62-9.65,38.6-14.48,68.93-14.48h19.3v51.35h-10.68c-22.98,0-38.6,3.85-46.87,11.55-8.27,7.7-12.41,26.02-12.41,54.97,0,51.01-1.15,86.74-3.45,107.19-2.3,20.45-8.62,37.91-18.96,52.39-10.34,14.48-26.88,26.88-49.63,37.22,24.13,9.19,42.16,24.07,54.11,44.63,11.94,20.57,17.92,54.28,17.92,101.16,0,43.2.63,70.54,1.9,82.03,1.26,11.49,5.63,20.22,13.1,26.19,7.46,5.97,22.23,8.96,44.29,8.96h10.68v51.35h-19.3c-22.52,0-40.21-2.19-53.08-6.55-12.87-4.37-24.07-12.58-33.6-24.64-9.54-12.06-15.63-27-18.27-44.81-2.64-17.81-3.96-46.13-3.96-84.96s-2.24-65.37-6.72-80.3c-4.48-14.93-12.29-26.31-23.44-34.12-11.15-7.81-24.87-11.94-41.19-12.41v-53.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M785.68,343.78c-16.54.46-30.33,4.6-41.36,12.41-11.03,7.81-18.78,19.25-23.26,34.29-4.48,15.05-6.72,41.76-6.72,80.13,0,49.4-2.76,83.8-8.27,103.22-5.51,19.41-16.09,33.89-31.71,43.43-15.63,9.53-38.6,14.3-68.93,14.3h-19.3v-51.01h10.68c22.97,0,38.6-3.85,46.87-11.55,8.27-7.7,12.41-26.02,12.41-54.97,0-51.23,1.15-87.08,3.45-107.53,2.29-20.45,8.62-37.85,18.96-52.21,10.34-14.36,26.88-26.71,49.63-37.05-24.13-9.19-42.17-24.13-54.11-44.8-11.95-20.68-17.92-54.34-17.92-100.98,0-43.2-.69-70.59-2.07-82.2-1.38-11.6-5.8-20.39-13.27-26.37-7.47-5.97-22.12-8.96-43.94-8.96h-10.68V2.58h19.3c22.52,0,40.21,2.19,53.08,6.55,12.87,4.37,24.07,12.58,33.6,24.64,9.53,12.06,15.62,27,18.27,44.8,2.64,17.81,3.96,46.13,3.96,84.96s2.18,65.37,6.55,80.3c4.36,14.94,12.18,26.37,23.44,34.29,11.26,7.93,25.04,12.01,41.36,12.24v53.42Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSvgNopadding);
export default __webpack_public_path__ + "static/media/Icon_svg_nopadding.39cebbae52edfc0f548fdfc78a05f3d6.svg";
export { ForwardRef as ReactComponent };